"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMM = function FlagMM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.82-76.65,37-13.24l66.85.51a4.25,4.25,0,0,1,2.48,7.66L52.53,34.64,72.7,98.37a4.25,4.25,0,0,1-6.52,4.73L11.8,64.23-42.58,103.1a4.24,4.24,0,0,1-6.51-4.73l20.16-63.73L-82.7-5.07a4.25,4.25,0,0,1,2.48-7.66l66.85-.51L7.77-76.65a4.24,4.24,0,0,1,8.05,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMM;
exports["default"] = _default;